export enum EFeatureFlags {
	EnableDarkMode = 'ENABLE_DARK_MODE',
	Demo = 'DEMO',
	UndoProposals = 'UNDO_PROPOSALS',
}
